import { render, staticRenderFns } from "./ReadAboutFr.vue?vue&type=template&id=7127da66"
import script from "./ReadAboutFr.vue?vue&type=script&lang=js"
export * from "./ReadAboutFr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports